
<div class="progress">
    <div class="progress-bar"></div>
</div>